<template>
    <a class="toggle-fullscreen" :title="buildTitle"
            @click="$emit('click')"
    >
        <span class=""><i :class="buildClass"></i> {{ buildTitle }}</span>
    </a>
</template>

<script>
    // Fullscreen is a misnomer - we're expanding to fit available browser space, not doing [F11] Full-Screen action
    export default {
        name: "ToggleFullScreen",
        props: {
            on: Boolean,
        },
        computed: {
            buildTitle() {
                // return this.on ? 'Minimise' : 'Maximise';
                return this.on ? 'Restore' : 'Expand';
            },
            buildClass() {
                return this.on ? 'icon-resize-small icon-white' : 'icon-resize-full icon-white';
            }
        },
    }
</script>

<style>
.toggle-fullscreen {
    display: inline-block;
    /* padding: 4px 10px; */
    color: #999;
    cursor: pointer;
}
.toggle-fullscreen:hover {
    color: #fff;
    text-decoration: none;
}
</style>